import { Module, VuexModule, Mutation } from 'vuex-module-decorators'
import { PendingOrdersSubscription } from '~/graphql/types'

@Module({
  name: 'order-pending',
  stateFactory: true,
  namespaced: true,
})
export default class OrderPending extends VuexModule {
  loading = true
  items: PendingOrdersSubscription['order'] = []

  @Mutation
  setLoading(loading) {
    this.loading = loading
  }

  @Mutation
  setItems(items) {
    this.items = items
  }
}
